import { PublicKey } from "@solana/web3.js";

export const PROGRAM_ID = new PublicKey(
  "B1x53qgNmAdZMfPVZvu89qDmNn3RpdKajRFXqCzE7UPU",
);
export const FEE_ROUTER_PROGRAM_ID = new PublicKey(
  "2Zqd5pzGhjZdN56AakBUZQnQSSvCik76Y6KpCrnrAE8X",
);
export const FRONTEND_FEE_RECIPIENT = new PublicKey(
  "Cq8PzTNebFj7b7aGMTthAhzBMLxa5CzhYhVV3eHaVEev",
);
export const FRONTEND_FEE_BPS = 100n;
export const CONFIG = new PublicKey(
  "FYCMNvqKSiGwtZfaFzYNVbve1kSPiD7MJgVNdKhrEhrQ",
);
export const PROTOCOL_CONFIG = new PublicKey(
  "2efNvZLZ4kceZzWoUYY7n4AqQgy8PAfQ6SrpYC8QjegS",
);
export const POOL_AUTHORITY = new PublicKey(
  "4rrMevYADw78PaHuYzPRtmHineckwMLDM3AuAgo5QXHm",
);
export const PROTOCOL_FEE_RECIPIENT = new PublicKey(
  "AJFbKBgzVMFCnggmr3YetjYA8m6zUagCj1meXiYPuJzq",
);
export const PLATFORM_FEE_RECIPIENT = new PublicKey(
  "CoYLwSdKzomWucaUEL2WsxznUDa5bTmM82qJUriPBrrA",
);
export const EVENT_AUTHORITY = new PublicKey(
  "6bdFuZomjz9KYvQVNCUgJkCqCHtGgnRT4DFnyGQ6wY3o",
);
export const PYTH_SOL_USD_PRICE_ACCOUNT = new PublicKey(
  "7UVimffxr9ow1uXYxsr4LHAcV58mLzhmwaeKvJ1pjLiE",
);
export const PYTH_RECEIVER_PROGRAM_ID = new PublicKey(
  "rec5EKMGg6MxZYaMdyBfgwp4d5rB9T1VQH5pJv5LtFJ",
);

export const LAMPORTS_PER_SOL_BIGINT = 1_000_000_000n;
export const VIRTUAL_SOL_LAMPORTS = 35n * LAMPORTS_PER_SOL_BIGINT;
export const BPS = 10_000n;
export const DEFAULT_SLIPPAGE_BPS = 500n;
export const POOL_ACCOUNT_SIZE = 372;
export const POOL_ACCOUNT_DISCRIMINATOR = "83fe279004b3867f";

export const RPC_ENDPOINT =
  import.meta.env.VITE_SOLANA_RPC_URL?.trim() ||
  "https://solana-rpc.publicnode.com";
export const RPC_FALLBACK =
  import.meta.env.VITE_RPC_FALLBACK_URL?.trim() ||
  "https://rpc.solanatracker.io/public";
const sameOriginHistoryRpc =
  typeof window !== "undefined" && /^https?:$/.test(window.location.protocol)
    ? new URL("/solana-rpc", window.location.origin).toString()
    : "https://api.mainnet-beta.solana.com";
const configuredHistoryRpc = import.meta.env.VITE_RPC_HISTORY_URL?.trim();
export const RPC_HISTORY =
  configuredHistoryRpc &&
  !configuredHistoryRpc.includes("api.mainnet-beta.solana.com")
    ? configuredHistoryRpc
    : sameOriginHistoryRpc;

const configuredPriorityFee = Number(
  import.meta.env.VITE_PRIORITY_FEE_MICROLAMPORTS || "10000",
);
export const PRIORITY_FEE_MICROLAMPORTS = Number.isFinite(
  configuredPriorityFee,
)
  ? Math.max(0, Math.round(configuredPriorityFee))
  : 10_000;

export const REFRESH_INTERVAL_MS = 20_000;
